import { ActionTypes } from '../actions';

export const rootReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_REGISTRATION_TYPE:
      return {
        ...state,
        registration_type: {
          ...state.registration_type,
          ...action.payload,
        },
      };

    case ActionTypes.TOGGLE_ADDON:
      return {
        ...state,
        addons: state.addons.map((addon) =>
          addon.id === action.payload ? { ...addon, active: !addon.active } : addon
        ),
      };

    case ActionTypes.REORDER_ADDONS:
      return {
        ...state,
        addons: action.payload,
      };

    case ActionTypes.ADD_ADDON:
      return {
        ...state,
        addons: [...state.addons, action.payload],
      };

    case ActionTypes.UPDATE_ADDON:
      return {
        ...state,
        addons: state.addons.map((addon) =>
          addon.id === action.payload.id ? { ...addon, ...action.payload } : addon
        ),
      };

    case ActionTypes.DELETE_ADDON:
      return {
        ...state,
        addons: state.addons.map((addon) =>
          addon.id === action.payload ? { ...addon, deleted: true } : addon
        ),
      };

    default:
      return state;
  }
};

export default rootReducer;